import { FeatureFlagEnum } from "@finway-group/shared/lib/models"
import { Switch } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { useAuth } from "~Shared/hooks/auth.hooks"
import { useIsPersonioEnabled } from "~Shared/hooks/featureFlags.hooks"
import { invalidateIntegrationCache } from "~Shared/queries/integration.queries"
import { useUpdateTenantFeatureFlag } from "~Shared/queries/tenant.queries"
import { NotificationService, NotificationTypeEnum } from "~Shared/services/notification.service"

// TODO: Remove once admin interface is setup
export const CsPersonioFeatureFlag = () => {
    const { t } = useTranslation()
    const { userClass } = useAuth()

    const [isLoading, setIsLoading] = useState(false)

    const isPersonioEnabled = useIsPersonioEnabled()
    const updateTenantFeatureFlag = useUpdateTenantFeatureFlag()

    if (userClass?.email !== PROCESS_ENV.FINWAY_ADMIN_EMAIL) {
        return null
    }

    const onEnablePersonioFeature = async () => {
        setIsLoading(true)

        updateTenantFeatureFlag.mutate(
            { featureFlag: FeatureFlagEnum.PERSONIO_ENABLED, isEnabled: true },
            {
                onSuccess: async () => {
                    invalidateIntegrationCache()
                    setIsLoading(false)
                },
                onError: (error) => {
                    setIsLoading(false)
                    NotificationService.send(NotificationTypeEnum.ERROR, t("error:error"), error?.toString())
                },
            },
        )
    }

    return (
        <div className="flex justify-between items-center mt-16">
            <span>{t("label:cs_feature_flags.personio_integration")}</span>
            <Switch checked={isPersonioEnabled} onChange={onEnablePersonioFeature} disabled={isPersonioEnabled} loading={isLoading} />
        </div>
    )
}
